import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Folder, Paperclip } from 'lucide-react';
const bonos = [{
  num: '01',
  title: 'KIT DE ARRANQUE RÁPIDO',
  desc: 'CV Anti-ATS operativo en menos de 60 minutos. Configuración paso a paso + plantilla base lista para editar hoy.',
  value: '$12.000'
}, {
  num: '02',
  title: 'BANCO EXPRESS DE PALABRAS CLAVE',
  desc: '200+ palabras clave organizadas por industria, cargo y nivel. Copiar, pegar y adaptar. Sin improvisar nunca más.',
  value: '$15.000'
}, {
  num: '03',
  title: 'PLANTILLAS PRO EDITABLES',
  desc: 'Estructuras visuales premium compatibles con ATS. Templates listos para Word y Google Docs.',
  value: '$10.000'
}, {
  num: '04',
  title: 'CHECKLIST MAESTRA DE POSTULACIÓN',
  desc: '18 checklists que cubren cada etapa del proceso. Desde armar el CV hasta negociar el sueldo.',
  value: '$10.000'
}, {
  num: '05',
  title: 'SCRIPTS DE ENTREVISTA LISTOS',
  desc: '30+ respuestas exactas para las preguntas más comunes. Preguntas de competencia, situacionales y de negociación salarial.',
  value: '$12.000'
}, {
  num: '06',
  title: 'PACK DE RECURSOS DESCARGABLES',
  desc: 'Trackers, planificadores y mini templates para organizar tu búsqueda semana a semana.',
  value: '$8.000'
}];
export function BonosSection() {
  return <section className="py-9 relative" data-id="element-18">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold/5 blur-[120px] rounded-full pointer-events-none" data-id="element-19"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-20">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative max-w-3xl mx-auto mb-8" data-id="element-21">
          {/* Outer glow */}
          <div className="absolute -inset-1 bg-gradient-to-r from-gold via-yellow-400 to-gold rounded-3xl blur-xl opacity-40 animate-pulse" data-id="element-22"></div>

          {/* Frame */}
          <div className="relative bg-gradient-to-br from-graphite via-petroleum to-graphite border-2 border-gold rounded-3xl p-5 md:p-7 text-center overflow-hidden shadow-2xl shadow-gold/30" data-id="element-23">
            {/* Grid pattern background */}
            <div className="absolute inset-0 opacity-[0.08] pointer-events-none" style={{
            backgroundImage: 'linear-gradient(rgba(212,166,42,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(212,166,42,0.6) 1px, transparent 1px)',
            backgroundSize: '24px 24px'
          }} data-id="element-24"></div>

            {/* Corner ribbons */}
            <div className="absolute top-0 left-0 w-16 h-16 border-t-4 border-l-4 border-gold rounded-tl-3xl pointer-events-none" data-id="element-25"></div>
            <div className="absolute top-0 right-0 w-16 h-16 border-t-4 border-r-4 border-gold rounded-tr-3xl pointer-events-none" data-id="element-26"></div>
            <div className="absolute bottom-0 left-0 w-16 h-16 border-b-4 border-l-4 border-gold rounded-bl-3xl pointer-events-none" data-id="element-27"></div>
            <div className="absolute bottom-0 right-0 w-16 h-16 border-b-4 border-r-4 border-gold rounded-br-3xl pointer-events-none" data-id="element-28"></div>

            <div className="relative z-10" data-id="element-29">
              <motion.div initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} className="inline-flex items-center gap-2 bg-gold text-graphite border border-gold px-4 py-1.5 rounded-full text-xs font-extrabold uppercase tracking-wider mb-3 shadow-lg shadow-gold/40" data-id="element-30">
                <Gift className="w-3.5 h-3.5" data-id="element-31" />
                Regalo Exclusivo
              </motion.div>
              <h2 className="text-3xl md:text-5xl font-extrabold flex items-center justify-center gap-3 md:gap-4 flex-wrap" data-id="element-32">
                <Gift className="w-8 h-8 md:w-10 md:h-10 text-gold drop-shadow-[0_0_8px_rgba(212,166,42,0.6)]" data-id="element-33" />
                <span className="text-white" data-id="element-34">6 BONOS</span>
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 via-gold to-yellow-500 drop-shadow-[0_0_12px_rgba(212,166,42,0.4)]" data-id="element-35">
                  INCLUIDOS
                </span>
                <Gift className="w-8 h-8 md:w-10 md:h-10 text-gold drop-shadow-[0_0_8px_rgba(212,166,42,0.6)]" data-id="element-36" />
              </h2>
              <div className="mt-2 mx-auto h-px w-32 bg-gradient-to-r from-transparent via-gold to-transparent opacity-70" data-id="element-37"></div>
              <p className="mt-2 text-lg md:text-xl text-gold font-bold uppercase tracking-widest" data-id="element-38">
                Siempre Gratis
              </p>
            </div>
          </div>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mb-5" data-id="element-39">
          {bonos.map((bono, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-gradient-to-b from-cardbg to-graphite border-2 border-gold/20 rounded-2xl p-5 transition-all duration-300 relative overflow-hidden hover:border-gold/50 hover:-translate-y-1 mt-4" data-id="element-40">
              {/* Card Folder Tab */}
              <div className="absolute top-0 left-4" data-id="element-41">
                <div className="bg-petroleum border-x border-b border-gold/40 px-3 py-1 rounded-b-md" data-id="element-42">
                  <span className="text-[10px] font-mono font-bold uppercase tracking-widest text-gold" data-id="element-43">
                    Bono {bono.num}
                  </span>
                </div>
              </div>

              {/* Stamp */}
              <div className="absolute top-4 right-4 z-20 pointer-events-none select-none" style={{
            transform: 'rotate(12deg)'
          }} data-id="element-44">
                <div className="border-2 border-gold/60 rounded px-2 py-0.5" data-id="element-45">
                  <span className="text-gold/80 font-extrabold tracking-widest text-[10px] uppercase" data-id="element-46">
                    Gratis
                  </span>
                </div>
              </div>

              {/* Ruled-paper lines */}
              <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
            backgroundImage: 'repeating-linear-gradient(0deg, #ffffff 0px, #ffffff 1px, transparent 1px, transparent 24px)',
            marginTop: '32px'
          }} data-id="element-47"></div>

              <h3 className="text-lg font-bold mb-2 pr-16 text-white mt-8 relative z-10" data-id="element-48">
                {bono.title}
              </h3>
              <p className="text-textsecondary text-sm mb-4 min-h-[60px] relative z-10" data-id="element-49">
                {bono.desc}
              </p>

              <div className="flex items-center justify-between pt-4 border-t border-dashed border-white/10 relative z-10" data-id="element-50">
                <span className="text-textsecondary line-through text-sm" data-id="element-51">
                  Valor: {bono.value}
                </span>
                <span className="text-gold font-bold" data-id="element-52">INCLUIDO</span>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto relative mt-8" data-id="element-53">
          {/* Total Value Folder Tab */}
          <div className="absolute -top-4 left-6 z-20" data-id="element-54">
            <div className="bg-petroleum border border-gold/40 rounded-t-lg px-3 py-1 flex items-center gap-1.5 transform -rotate-1" data-id="element-55">
              <Folder className="w-3 h-3 text-gold" data-id="element-56" />
              <span className="text-[10px] font-mono font-bold uppercase tracking-widest text-gold" data-id="element-57">
                Presupuesto Total
              </span>
            </div>
          </div>

          <div className="bg-gold/10 border border-gold/30 rounded-xl p-5 text-center relative z-10" data-id="element-58">
            <p className="text-xl md:text-2xl font-bold" data-id="element-59">
              Valor total bonos:{' '}
              <span className="line-through text-textsecondary mx-2" data-id="element-60">
                $67.000
              </span>
              <span className="text-gold" data-id="element-61">→ GRATIS con tu Compra</span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}